// extracted by mini-css-extract-plugin
export default {"root":"wiwhTN","bg":"WQWmZQ","arrow":"E6tIzY"};